import { IPaymentOfferModel, IProductModel, isAnnualPeriod } from "@nf/common";
import { useTranslation } from "next-i18next";

import { useIsAuthenticated } from "hooks";

export const useOfferSavingsText = (
  offer: IPaymentOfferModel | IProductModel
) => {
  const { t } = useTranslation("translations");
  const { isRegisteredViaCampaign } = useIsAuthenticated();

  if (isRegisteredViaCampaign) {
    if (isAnnualPeriod(offer.Period)) {
      return t("web_choose_subscription_annual_save_aeldresagen");
    }

    return t("web_choose_subscription_monthly_save_aeldresagen");
  }

  if (isAnnualPeriod(offer.Period)) {
    return t("web_choose_subscription_annual_save");
  }

  return "";
};

export default useOfferSavingsText;
